export default {
  Title: 'Family',
  Add: 'Add family member',
  AddTitle: 'Add a family member',
  EditTitle: 'Edit family member',
  Empty: 'No family members yet.',
  NotEditable: 'Added before relationships were recorded. It cannot be edited here yet.',
  NoEmail: 'No email',
  NoPhone: 'No phone',
  PriorityTooltip: 'Contact priority',
  PrimaryContact: 'Primary contact',
  PrimaryContactTooltip: 'The primary contact cannot be removed. Give another member a lower priority number first.',
  Save: 'Save',
  Cancel: 'Cancel',
  InvalidEmail: 'Enter a valid email address.',
  InvalidPhone: 'Enter a Canadian or US phone number.',
  Fields: {
    FirstName: 'First name',
    LastName: 'Last name',
    Relationship: 'Relationship',
    Priority: 'Priority',
    Email: 'Email',
    Phone: 'Phone',
    Roles: 'Roles',
  },
  Relationship: {
    CHILD: 'Child',
    CHILD_IN_LAW: 'Child-in-law',
    SPOUSE_PARTNER: 'Spouse or partner',
    PARENT: 'Parent',
    GRANDCHILD: 'Grandchild',
    SIBLING: 'Sibling',
    NIECE_NEPHEW: 'Niece or nephew',
    COUSIN: 'Cousin',
    OTHER_FAMILY: 'Other family',
    FRIEND: 'Friend',
    PROFESSIONAL: 'Professional',
    SELF: 'Self',
  },
  FamilyName: {
    Title: 'Family name',
    Empty: 'No family name',
    EditTitle: 'Rename family',
  },
  Role: {
    CARE_COORDINATOR: 'Care coordinator',
    BILLING_CONTACT: 'Billing contact',
    DECISION_MAKER: 'Decision maker',
  },
  Notes: {
    FamilyNotes: {
      Title: 'Family notes',
      Empty: 'No family notes',
      EditTitle: 'Edit family notes',
    },
    ClientNotes: {
      Title: 'Client notes',
      Empty: 'No client notes',
      EditTitle: 'Edit client notes',
    },
    Error: 'Could not save the notes. Try again.',
  },
  Errors: {
    FAM_002: 'This email or phone number is already used by someone in this family.',
    FAM_003: 'Check the fields and try again.',
    FAM_006: 'This family member was already removed. Refresh to see the latest.',
    FAM_007: 'This email is already in use.',
    FAM_008: 'This phone number is already in use.',
    FAM_009: 'Enter a first and last name.',
    FAM_010: 'Enter a valid email address.',
    FAM_011: 'Enter a valid phone number.',
    FAM_012: 'Choose a relationship.',
    FAM_013: 'Priority must be a whole number.',
    FAM_014: 'Choose each role only once.',
    FAM_015: 'The primary contact cannot be removed. Give another member a lower priority number first.',
    FAM_016: 'Enter a family name.',
    Default: 'Could not save the family member. Try again.',
  },
};
